// namespace
export const TITLE_NAMESPACE = 'title'

// getters

// mutations
export const TITLE_MUTATION = 'updateTitle'

// actions
export const TITLE_ACTION_GET_TITLE = 'fetchTitle'



// WEBPACK FOOTER //
// ./src/store/modules/title-types.js